export function useCheckSearchCriteriaExists (model) {

    for(const prop in model) {

        if(model[prop]) {

            return true;

        }

    }

    return false

}
